module.exports = __webpack_public_path__ + "static/media/commentIcon.076e4e2f.svg";